<template>
  <div class="more-card" @click="$emit('more-click')">
    <div class="image-container">
      <div class="overlay"></div>
      <div class="more-icon">
        <div class="more-dots">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
    <div class="card-title">更多</div>
  </div>
</template>

<script>
export default {
  name: 'MoreCard'
}
</script>

<style scoped>
.more-card {
  width: 100%;
  cursor: pointer;
  transition: all 0.3s;
  margin-bottom: 15px;
}

.more-card:hover {
  transform: translateY(-5px);
}

.image-container {
  position: relative;
  width: 100%;
  padding-top: 135%; /* 1:1.3 比例，正方形 */
  overflow: hidden;
  border-radius: 4px;
  background-image: url('../assets/gengduo.jpg');
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
}

.more-icon {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

.more-dots {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 10px;
  width: 40px;
  height: 40px;
}

.more-dots span {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  border-radius: 50%;
}

.card-title {
  margin-top: 10px;
  font-size: 16px;
  color: #333;
  text-align: center;
}
</style> 